import React, { useState } from 'react';
import { View, Text, StyleSheet } from 'react-native';

import {
  downloadReport,
  DownloadButton
} from 'app/src/elements/ReportDownload';
import SearchableSelect from 'app/src/elements/SearchableSelect';
import { saleOptions } from './filterOptions';

import { cardStyles as styles } from './index';

const SoldAssetsStatusReport = ({ data }) => {
  const [saleId, setSaleId] = useState(null);

  const handleDownload = downloadProps => {
    downloadReport({
      ...downloadProps,
      path: 'sold-assets-status-report',
      params: { 'sale-id': saleId }
    });
  };

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Sold Assets Status Report</Text>
      <Text style={styles.label}>Sale:</Text>
      <SearchableSelect
        placeholder="Select Sale"
        options={saleOptions(data)}
        value={saleId}
        onChange={setSaleId}
      />
      <DownloadButton handleDownload={handleDownload} />
    </View>
  );
};

export default SoldAssetsStatusReport;
